import { ServiceMaker, methods, services } from "../services";
import Api from "@/services/service-v2";

export const listOrderForTenant = (data) =>
  ServiceMaker(
    `/api/v1/order/listbytenant/${data.id}?n=${data.count}&isMaster=true${
      data.orderStatus ? "&orderStatus=" + data.orderStatus : ""
    }`,
    methods.GET,
    services.order
  );

export const listOrderForSeller = (count) =>
  ServiceMaker(
    `/api/v1/get/listbyseller/status/all?n=${count}&isMaster=true`,
    methods.GET,
    services.order
  );

export const getOrderDetails = (payload) =>
  Api().$http.get(`/order/api/v2/order/detail-by-id/${payload}`);

export const listOrderForAllUsers = (payload) => {
  let orderUrl = `/api/v1/get/listbyseller/status/all?provider=${payload.provider}&isMaster=true`;
  if (payload.orderStatus) {
    orderUrl = orderUrl + `&orderStatus=${payload.orderStatus}`;
  }
  if (payload.time) {
    orderUrl = orderUrl + `&n=${payload.time}`;
  }
  if (payload.fromDate && payload.toDate) {
    orderUrl =
      orderUrl + `&fromDate=${payload.fromDate}&toDate=${payload.toDate}`;
  }
  if (payload.page && payload.limit) {
    orderUrl = orderUrl + `&limit=${payload.limit}&page=${payload.page}`;
  }
  if (payload.type && payload.typeVal) {
    orderUrl = orderUrl + `&${payload.type}=${payload.typeVal}`;
  }
  return ServiceMaker(orderUrl, methods.GET, services.order);
};

export const listOrderForManufacturer = (count) =>
  ServiceMaker(
    `/api/v1/get/listbymanufacturer?n=${count}&isMaster=true`,
    methods.GET,
    services.order
  );

export const updatePickupTime = (data) =>
  ServiceMaker(`/api/v1/updates`, methods.POST, services.order, data);

export const getPartner30daysorderscount = () =>
  ServiceMaker(`/stats/partnerMonthlyOrders`, methods.GET, services.order);

export const getTenant30daysorderscount = (Id) =>
  ServiceMaker(`stats/tenantMonthlyOrders/${Id}`, methods.GET, services.order);

export const getPartnerSalesGroup = () =>
  ServiceMaker(`stats/partnerSales`, methods.GET, services.order);

export const getTenantSalesGroup = (Id) =>
  ServiceMaker(`stats/tenantSales/${Id}`, methods.GET, services.order);

export const getInvoiceData = (orderId) =>
  ServiceMaker(`packaging/invoice/${orderId}`, methods.GET, services.order);

export const getTotalDeliveryCost = () =>
  ServiceMaker(`stats/total-delivery-cost`, methods.GET, services.order);

export const getCheckoutHistory = (payload) =>
  ServiceMaker(
    `checkout/history-list`,
    methods.POST,
    services.checkout,
    payload
  );

export const setDeliveryAgent = (payload) =>
  Api().$http.post(`order/api/v1/updates/set-delivery-agent`, payload);
